import { useState, useRef, Fragment } from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useFeature } from '@growthbook/growthbook-react'

import { useDetectClickOutside } from 'hooks'
import { logEvent } from 'lib/analytics'
import { EXTERNAL_PATH, ROUTE_PATH } from 'lib/paths'
import { useCurrentUser } from 'store/api/yay/user'
import { logout } from 'store/ducks/auth'

import Avatar from 'components/Avatar'
import Nickname from 'components/Nickname'
import { NavItem } from './NavItem'

import './style.scss'

export const UserMenu = () => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const { data: currentUser } = useCurrentUser()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useDetectClickOutside(menuRef, () => setMenuOpen(false), isMenuOpen)

  const onToggleMenu = () => {
    setMenuOpen(!isMenuOpen)
  }

  const isEmplGiftsEnabled = useFeature('yay-17610')?.on

  return (
    <div
      className={cx(
        `Menu Menu--open-downwards`,
        isMenuOpen && 'Menu--active',
        `Menu--white`,
        'UserMenu'
      )}
      ref={menuRef}
    >
      <div className={cx('UserMenu__handler')} onClick={onToggleMenu}>
        <Avatar user={currentUser} showVipCircle />

        <Nickname user={currentUser} />

        <span className="Menu__handle Menu__handle--dropdown" />
      </div>

      <div className={cx('Menu__panel', 'Menu__panel--no-arrow')}>
        <ul className="Menu__panel__ul">
          <NavItem
            className="Menu__panel__ul__profile"
            to={ROUTE_PATH.USER(currentUser?.id)}
            onClick={() => {
              onToggleMenu()
              logEvent.navigation_pane_select({ destination: 'Profile' })
            }}
          >
            <Avatar user={currentUser} showVipCircle />
            <div>
              <div className="Menu__panel__ul__profile__nickname">
                <h4>{currentUser?.nickname}</h4>
                {currentUser?.vip && (
                  <img
                    src="/images/icon-vip.svg"
                    alt="VIP Badge"
                    width={22}
                    height={18}
                  />
                )}
              </div>
              <p>{t('common.see_profile')}</p>
            </div>
          </NavItem>

          {isEmplGiftsEnabled && (
            <Fragment>
              <NavItem
                onClick={() => {
                  onToggleMenu()
                  logEvent.navigation_pane_select({ destination: 'EMPL' })
                }}
                to={ROUTE_PATH.EMPL_DETAILS}
              >
                <img
                  className="Menu__panel__ul__a__icon"
                  src="/images/header-ul-a-empl.svg"
                />
                {t('common.empl')}
              </NavItem>

              <NavItem
                onClick={() => {
                  onToggleMenu()
                  logEvent.navigation_pane_select({ destination: 'Gift' })
                }}
                to={ROUTE_PATH.USER_GIFTS(currentUser?.id)}
              >
                <img
                  className="Menu__panel__ul__a__icon"
                  src="/images/header-ul-a-gift.svg"
                />
                {t('common.gift')}
              </NavItem>
            </Fragment>
          )}

          <NavItem
            onClick={() => {
              onToggleMenu()
              logEvent.navigation_pane_select({ destination: 'Settings' })
            }}
            to={ROUTE_PATH.SETTING_EMAIL}
          >
            <img
              className="Menu__panel__ul__a__icon"
              src="/images/icon-cog.svg"
              alt="Cog icon"
            />
            {t('common.setting')}
          </NavItem>

          <NavItem
            onClick={() => {
              onToggleMenu()
              logEvent.navigation_pane_select({ destination: 'About' })
            }}
            to={EXTERNAL_PATH.LANDING_PAGE()}
            external
          >
            <img
              className="Menu__panel__ul__a__icon"
              src="/images/header-ul-a-about.svg"
            />
            {t('common.portal')}
          </NavItem>

          {/* <NavItem
            onClick={() => {
              onToggleMenu()
            }}
          >
            <img
              className="Menu__panel__ul__a__icon"
              src="/images/icon-conference-call-join-by-users.svg"
              alt="Two persons icon"
            />
            他のアカウントでログイン
          </NavItem> */}

          <NavItem
            onClick={() => {
              onToggleMenu()
              logEvent.navigation_pane_select({ destination: 'Bookmarks' })
            }}
            to={ROUTE_PATH.BOOKMARKS}
          >
            <img
              className="Menu__panel__ul__a__icon"
              src="/images/header-ul-a-bookmark.svg"
              alt="Bookmark icon"
            />
            {t('common.bookmarks')}
          </NavItem>

          <NavItem
            onClick={(e) => {
              e.preventDefault()
              onToggleMenu()
              logEvent.navigation_pane_select({ destination: 'Logout' })
              dispatch(logout())
            }}
          >
            <img
              className="Menu__panel__ul__a__icon"
              src="/images/icon-exit.svg"
              alt="Exit door"
            />
            {t('common.logout')}
          </NavItem>
        </ul>
      </div>
    </div>
  )
}
